import { NavLink, Link, Outlet } from 'react-router-dom';
import SpeciesMenu from './components/SpeciesMenu';

const navigation = [
  { name: 'Home', href: '/' },
  { name: 'Downloads', href: '/downloads' },
];

// Light species fills (yellow / orange / pink / teal) need dark chrome text.
const LIGHT_BG = ['bg-cannaviz', 'bg-prunviz', 'bg-strawviz', 'bg-chlamviz'];

const Layout = (props) => {
  const { colorBg, logoHeader, showSpecies, setShowSpecies } = props;
  const navDark = LIGHT_BG.includes(colorBg);

  const brandText = navDark ? 'text-ink' : 'text-white drop-shadow-sm';
  const linkActive = 'bg-white text-ink shadow-soft';
  const linkIdle = navDark
    ? 'text-ink/70 hover:bg-black/10 hover:text-ink'
    : 'text-white/90 hover:bg-white/20 hover:text-white';

  return (
    <div className="min-h-screen flex flex-col">
      {/* Top utility bar — tinted with the active species colour */}
      <nav className={`${colorBg} relative`}>
        {!navDark && (
          <div className="absolute inset-0 bg-gradient-to-b from-black/15 to-transparent pointer-events-none" />
        )}
        <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="flex h-16 items-center justify-between">
            <Link to="/" className="flex items-center gap-3 group">
              <span
                className="w-9 h-9 bg-no-repeat bg-center bg-contain drop-shadow"
                aria-hidden="true"
              />
              <span className={`font-display text-xl font-semibold tracking-tight ${brandText}`}>
                Plantae<span className="italic font-normal">Viz</span>
              </span>
            </Link>

            <div className="flex items-center gap-1.5">
              {navigation.map((item) => (
                <NavLink
                  key={item.name}
                  to={item.href}
                  end={item.href === '/'}
                  className={({ isActive }) =>
                    [
                      'rounded-full px-4 py-1.5 text-sm font-medium tracking-wide transition-all duration-200',
                      isActive ? linkActive : linkIdle,
                    ].join(' ')
                  }
                >
                  {item.name}
                </NavLink>
              ))}
            </div>
          </div>
        </div>
      </nav>

      {/* Per-species SVG header banner */}
      <header className="bg-white shadow-soft" style={{ height: '450px' }}>
        <Link to="https://tomsbiolab.com/">
          <div
            className="w-80 h-60 bg-cover bg-center bg-no-repeat mx-auto"
            style={{ width: '100%', height: '500px', backgroundImage: 'url(' + logoHeader + ')' }}
          />
        </Link>
      </header>

      <main className="flex-1">
        <div className="border-y border-moss-200/70 bg-gradient-to-b from-moss-50 to-paper w-full py-8 px-6">
          <SpeciesMenu showSpecies={showSpecies} setShowSpecies={setShowSpecies} />
        </div>
        <div className="mx-auto py-10 px-5 sm:px-8" style={{ maxWidth: '1400px' }}>
          <Outlet />
        </div>
      </main>

      <footer className="border-t border-moss-200/70 bg-moss-900 text-moss-100">
        <div className="mx-auto max-w-7xl px-6 py-8 flex flex-col sm:flex-row items-center justify-between gap-3">
          <div className="flex items-center gap-3">
            <span
              className="w-7 h-7 bg-no-repeat bg-center bg-contain opacity-90"
              aria-hidden="true"
            />
            <span className="font-display text-lg">PlantaeViz</span>
          </div>
          <p className="text-sm text-moss-100/70 text-center sm:text-right">
            TOMSBioLab · Institute for Integrative Systems Biology (I2SysBio, UV-CSIC)
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Layout;
